module.exports = __webpack_public_path__ + "img/RUWABodenseeAG_RGB.239620f9.svg";